import React from "react";
import style from "../css/ValidationError.module.css";

const ValidationError = (props) => {
  const { field } = props;
  return <p className={style.error}>{field} is invalid.</p>;
};

export default ValidationError;
